<script>
	// Stores 
	import { 
		textSite, 
		linkAV,
		linkBoletoFacil 
	} from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Vitrine		from '../components/Vitrine.svelte'

   	// Code	
	let titlePage = 'Orientações sobre Boletos';
</script>
<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container clearfix">
	<div class="flex sm-flex-column">
		<div class="flex-1">
			<h5 class="text-bold pt-20">Confira estas informações no seu boleto:</h5>
			<p class="mt-20">Antes do pagamento, sempre confira o seu boleto e evite transtornos e prejuízos.</p>
			<img src="/assets/images/BoletoExemplo.jpg" alt="Boleto" style="max-width: 100%" />
			<ul class="flex flex-column gap-20">
				<li><span style="color: #fb0102;"><b>Em Vermelho:</b></span> Confira os dados do beneficiário, que sempre deverá ser <b>Freire Consultoria Imobiliária LTDA - CNPJ 11.970.722/0001-95</b> ou <b>Freire Adm. e Serviços Prediais Ltda - CNPJ 10.420.067/0001-39</b>.</li>
				<li><span style="color: #02aef6;"><b>Em Azul:</b></span> Confira o número e o nome do banco, que sempre deverá ser <b>Banco do Brasil (001)</b></li>
				<li><span style="color: #e58300;"><b>Em Laranja:</b></span> Confira os três primeiros dígitos da linha digitável do seu boleto, eles devem ser os primeiros números que identificam o banco, que sempre deverá ser <b>001</b></li>
				<li><span style="color: #70ad46;"><b>Em Verde:</b></span> Confira os últimos números da linha digitável, estes devem ser iguais ao valor do pagamento, neste exemplo <b>57161</b> (pois o valor do exemplo é R$ 571,61).</li>
			</ul>
		</div>
		<div class="flex-1">
			<h5 class="text-bold pt-20">Confira estas informações no seu boleto:</h5>
			<p class="mt-20">Antes do pagamento, sempre confira o seu boleto e evite transtornos e prejuízos.</p>
			<div class="flex flex-column gap-10 flex-center">
				<a target="_blank" href="https://api.whatsapp.com/send?phone=555133964477&text=Boleto%20F%C3%A1cil:%20Envie%20essa%20mensagem%20e%20aguarde%20instru%C3%A7%C3%B5es." class="btn btn-whatsapp btn-lg btn-bold hide"><i class="fab fa-whatsapp"></i> Solicite seu boleto via Whatsapp</a>
				<a target="_blank" href="{$linkBoletoFacil}" class="btn btn-secondary btn-lg btn-bold "><i class="fas fa-envelope"></i> Solicite Seu Boleto por Email</a>
				<a target="_blank" href="{$linkAV}" class="btn btn-primary btn-lg btn-bold "><i class="fas fa-arrow-alt-circle-right"></i> Acesse pelo Freire Online</a>
			</div>
		</div>
	</div>
</div>